import { twMerge } from "tailwind-merge";

import { ErrorImage } from "./ErrorImage";

export const ErrorView = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={twMerge(
      "flex h-full w-full flex-col items-center justify-center gap-4 p-2 text-center text-sm text-neutral-500",
      className
    )}
  >
    <ErrorImage />
    {children}
  </div>
);
